const NotFound = () => {
  return (
    <section
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1>Not Found</h1>
    </section>
  );
};

export default NotFound;
